import React, { useEffect } from "react";
import {
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import AppContainerPage from "./pages/AppContainerPage/AppContainerPage";
import GlobalStyles from "./GlobalStyle";

import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { oktaConfig } from "./config/oktaConfig";
import MainRouter from "./routes/MainRouter";
import AppRouter from "./routes/AppRouter";

const oktaAuth = new OktaAuth(oktaConfig);

const restoreOriginalUri = async (
  _oktaAuth: OktaAuth,
  originalUri: string | undefined
) => {
  window.location.replace(
    toRelativeUrl(originalUri || "/", window.location.origin)
  );
};

function App() {
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Router>
        <AppRouter />
      </Router>
    </Security>
  );
}

export default App;
